import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material components
import { } from '@material-ui/core';

import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// utils
import DateFnsUtils from '@date-io/date-fns';


const useStyles = makeStyles({
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
});

export function CustomDateFilter(props) {

    const classes = useStyles();

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                size="small"
                value={props.value}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                onChange={e => props.onChange(e)}
                KeyboardButtonProps={{ 'aria-label': 'filter date' }}
                InputAdornmentProps={{ position: "start" }}
            />
        </MuiPickersUtilsProvider>
    );
}